import { render, staticRenderFns } from "./addTel.vue?vue&type=template&id=6dcce35a&scoped=true"
import script from "./addTel.vue?vue&type=script&lang=js"
export * from "./addTel.vue?vue&type=script&lang=js"
import style0 from "./addTel.vue?vue&type=style&index=0&id=6dcce35a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcce35a",
  null
  
)

export default component.exports